import React, { useEffect, useState } from "react";
import { notify } from "react-notify-toast";
import Select from "react-select";
import db from "../firebase";

export default function WaiterPannelSingup() {
  const [selectedBranch, setselectedBranch] = useState("");
  const [branches, setbranches] = useState("");
  const [selectedMerchant, setselectedMerchant] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [confirmpass, setconfirmpass] = useState("");
  const [u, setuser] = useState(JSON.parse(localStorage.getItem("Ubytes")));
  const [merchantList, setMerchantList] = useState([]);
  const loadBranch = async () => {
    if (u.role === "Superadmin") {
      if (selectedMerchant === "") {
        notify.show("Please select a merchant", "warning");
        return;
      }
      let branches = await db
        .collection("Branches")
        .where("of", "==", selectedMerchant.uid)
        .get();
      let branchList = [];

      branches.forEach((branch) => {
        let _ = branch.data();
        _["value"] = branch.data().branchName;
        _["label"] = branch.data().branchName;
        branchList.push(_);
      });
      setbranches(branchList);
      return;
    }
    let branches = await db
      .collection("Branches")
      .where("of", "==", u.uid)
      .get();
    let branchList = [];

    branches.forEach((branch) => {
      let _ = branch.data();
      _["value"] = branch.data().branchName;
      _["label"] = branch.data().branchName;
      branchList.push(_);
    });
    setbranches(branchList);
  };
  const loadMerchant = async () => {
    let merchants = await db.collection("Merchant").get();
    let merchantList = [];
    merchants.forEach((merchant) => {
      let _ = merchant.data();
      _["value"] = merchant.data().brandName;
      _["label"] = merchant.data().brandName;
      merchantList.push(_);
    });
    // console.log(merchantList);
    setMerchantList(merchantList);
  };
  useEffect(async () => {
    if (u.role === "Merchant") {
      loadBranch();
    } else if (u.role === "Branch") {
      let branch = await db.collection("Branches").doc(u.branchId).get();
      let _ = branch.data();
      _["value"] = branch.data().branchName;
      _["label"] = branch.data().branchName;
      setselectedBranch(branch);
    } else if (u.role === "Superadmin") {
      loadMerchant();
    }
  });
  const updatePannel = async () => {
    if (password != confirmpass) {
      notify.show("Password are not same", "warning");
      return;
    }
    if (email === "") {
      notify.show("Please fill email", "warning");
      return;
    }
    if (u.role === "Superadmin") {
      if (selectedMerchant === "" || selectedBranch === "") {
        notify.show("Please select branch and merchant", "warning");
        return;
      }
      await db.collection("users").add({
        role: "waiter",
        email: email,
        password: password,
        of: selectedBranch.branchId,
        ofMerchant: selectedMerchant.uid,
      });
      notify.show("Waiter pannel signed up Successfully!", "success");
      return;
    }

    if (selectedBranch === "") {
      notify.show("Please select a branch", "warning");
      return;
    }
    await db.collection("users").add({
      role: "Waiter",
      email: email,
      password: password,
      of: selectedBranch.branchId,
      ofMerchant: u.role === "Merchant" ? u.uid : u.of,
    });
    notify.show("Waiter pannel signed up Successfully!", "success");
    setselectedBranch("");
    setemail("");
    setpassword("");
    setconfirmpass("");
  };
  return (
    <div className="waiter-signup">
      <p style={{ marginBottom: "10px" }}>Waiter Sign up form</p>
      <div className="waiter-card">
        <div className="waiter-row">
          {u.role === "Branch" ? null : (
            <Select
              placeholder={
                u.role === "Branch" ? "Select Branch" : "Select Merchant"
              }
              onBlur={loadBranch}
              options={u.role === "Superadmin" ? merchantList : branches}
              onChange={(e) => {
                u.role === "Superadmin"
                  ? setselectedMerchant(e)
                  : setselectedBranch(e);
              }}
            ></Select>
          )}
          <br></br>
          {u.role === "Superadmin" ? (
            <Select
              placeholder={"Select Branch"}
              options={branches}
              onChange={(e) => setselectedBranch(e)}
            ></Select>
          ) : null}
        </div>
        <div className="waiter-row">
          <div className="waiter-form">
            <p>Email</p>
            <input onChange={(e) => setemail(e.target.value)}></input>
            <p>Password</p>
            <input onChange={(e) => setpassword(e.target.value)}></input>
            <p>Confirm Password</p>
            <input onChange={(e) => setconfirmpass(e.target.value)}></input>
          </div>
          <button onClick={updatePannel} style={{ alignSelf: "center" }}>
            Signup
          </button>
        </div>
      </div>
    </div>
  );
}
